(function() { window.GUID_505db0c7_96c0_47d0_9286_e653af903443 = { getGuid: function() { return "505db0c7-96c0-47d0-9286-e653af903443"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let TimeFrame;
        (function (TimeFrame) {
            TimeFrame[TimeFrame["Current"] = 0] = "Current";
            TimeFrame[TimeFrame["Year"] = 1] = "Year";
            TimeFrame[TimeFrame["NextWeek"] = 2] = "NextWeek";
            TimeFrame[TimeFrame["NextMonth"] = 3] = "NextMonth";
            TimeFrame[TimeFrame["NextYear"] = 4] = "NextYear";
            TimeFrame[TimeFrame["LastWeek"] = 5] = "LastWeek";
            TimeFrame[TimeFrame["LastMonth"] = 6] = "LastMonth";
            TimeFrame[TimeFrame["LastYear"] = 7] = "LastYear";
            TimeFrame[TimeFrame["Older"] = 10] = "Older";
            TimeFrame[TimeFrame["All"] = 100] = "All";
        })(TimeFrame = Enumeration.TimeFrame || (Enumeration.TimeFrame = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=TimeFrame.pre.js.map
